//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShortInviteExpire: FeatureFlag = {"Id":"ShortInviteExpire","Label":"(QA) Expire invites after 1 minute","Impact":"For testing invite expiration. Submission invites expire after 1 minute","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
